import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlidesWideAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M18 4H2V16H6V20H22V8H18V4ZM4 14H6V8H16V6H4V14ZM11 15V13H13V11H15V13H17V15H15V17H13V15H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesWideAdd;
